// Components/Pages/Admin/Pillars.jsx
import { useState, useEffect } from "react";
import AdminTable from "./AdminTable";
import AdminForm from "./AdminForm";
import { api } from "./api";

const Pillars = () => {
  const [pillars, setPillars] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showForm, setShowForm] = useState(false);
  const [editingPillar, setEditingPillar] = useState(null);

  useEffect(() => {
    fetchPillars();
  }, []);

  const fetchPillars = async () => {
    try {
      const data = await api.getPillars();
      setPillars(data);
    } catch (error) {
      console.error('Error fetching pillars:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleAdd = () => {
    setEditingPillar(null);
    setShowForm(true);
  };

  const handleEdit = (pillar) => {
    setEditingPillar(pillar);
    setShowForm(true);
  };

  const handleDelete = async (id) => {
    if (window.confirm('Are you sure you want to delete this pillar?')) {
      try {
        await api.deletePillar(id);
        await fetchPillars();
      } catch (error) {
        console.error('Error deleting pillar:', error);
      }
    }
  };

  const handleSubmit = async (data) => {
    try {
      if (editingPillar) {
        await api.updatePillar(editingPillar.id, data);
      } else {
        await api.createPillar(data);
      }
      setShowForm(false);
      await fetchPillars();
    } catch (error) {
      console.error('Error saving pillar:', error);
    }
  };

  const columns = [
    { key: 'title', label: 'Title' },
    { key: 'tag', label: 'Tag' },
    { key: 'description', label: 'Description', render: (val) => val?.substring(0, 100) + (val?.length > 100 ? '...' : '') },
  ];

  const fields = [
    { name: 'title', label: 'Title', required: true, placeholder: 'Enter pillar title' },
    { name: 'tag', label: 'Tag', required: true, placeholder: 'e.g., Gender Equality' },
    { 
      name: 'tag_color', 
      label: 'Tag Color', 
      type: 'select',
      options: [
        { value: 'bg-pink-100 text-pink-700', label: 'Pink' },
        { value: 'bg-green-100 text-green-700', label: 'Green' },
        { value: 'bg-blue-100 text-blue-700', label: 'Blue' },
        { value: 'bg-emerald-100 text-emerald-700', label: 'Emerald' },
        { value: 'bg-purple-100 text-purple-700', label: 'Purple' },
        { value: 'bg-yellow-100 text-yellow-700', label: 'Yellow' },
        { value: 'bg-red-100 text-red-700', label: 'Red' },
      ]
    },
    { name: 'description', label: 'Description', type: 'textarea', required: true, rows: 5 },
    { 
      name: 'projects', 
      label: 'Projects (comma separated)', 
      type: 'textarea', 
      rows: 2,
      help: 'Enter project names separated by commas'
    },
  ];

  if (loading) {
    return <div className="text-center py-8">Loading...</div>;
  }

  return (
    <div>
      <AdminTable
        title="Thematic Pillars"
        columns={columns}
        data={pillars}
        onAdd={handleAdd}
        onEdit={handleEdit}
        onDelete={handleDelete}
        addButtonLabel="Add Pillar"
      />

      {showForm && (
        <AdminForm
          title="Thematic Pillar"
          fields={fields}
          initialData={editingPillar || {}}
          onSubmit={handleSubmit}
          onCancel={() => setShowForm(false)}
          isEditing={!!editingPillar}
        />
      )}
    </div>
  );
};

export default Pillars;